import { render, staticRenderFns } from "./EditTHGCarVRCs.vue?vue&type=template&id=729950f5&scoped=true"
import script from "./EditTHGCarVRCs.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditTHGCarVRCs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EditTHGCarVRCs.vue?vue&type=style&index=0&id=729950f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729950f5",
  null
  
)

export default component.exports